export const API_URL = 'https://uandistoreapi.herokuapp.com';

//dev url
// export const API_URL = 'http://localhost:3000';
